import { useQuery } from '@tanstack/react-query';
import { IDriverDetails } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getDriverDetails = async (id?: string) => {
  let res = await apiManager.get<IDriverDetails>(`/admin/driver/${id}`);
  return res;
};


export const useGetDriverDetails = (id?: string) =>
  useQuery({
    queryKey: ["get_driver_details", id],
    queryFn: async (): Promise<IDriverDetails> => {
      const res = await apiClient.get(ENDPOINTS.DRIVER.GET_DRIVER_DETAILS(id!));
      return res.data;
    },
    enabled: !!id,
  });